import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-242ba5aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-list" }
const _hoisted_2 = { class: "pay-detail" }
const _hoisted_3 = {
  key: 0,
  class: "price-item xag-flex-lr total"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "订单金额", -1))
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "price-item xag-flex-lr" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = {
  key: 0,
  class: "price-item xag-flex-lr"
}
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "price-item xag-flex-lr total" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "price-item xag-flex-lr" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "订单金额", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "price-item xag-flex-lr" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("定金 "),
  /*#__PURE__*/_createElementVNode("span", { class: "pay-status payed" }, "已付款 ")
], -1))
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "price-item xag-flex-lr total" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "订单金额", -1))
const _hoisted_20 = { class: "value" }
const _hoisted_21 = {
  key: 2,
  class: "change-item xag-flex-center"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "更改套餐", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right-green-svg" }, null, -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]

import { ref, Ref, computed, ComputedRef, withDefaults } from 'vue'
import { useRouter, Router } from 'vue-router'
import { ProductItem, ChildProductItem } from '@/types/device-replace-v3'
import RecordBlockWrapper from './record-block-wrap.vue'
import ActivityProduct from './activity-product-item.vue'
import { Dialog } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'record-product-block',
  props: {
    productGuid: { default: '' },
    productName: { default: '' },
    productImages: { default: () => [''] },
    productChild: { default: () => [] },
    guid: { default: '' },
    title: { default: '' },
    status: { default: 1 },
    canChange: { type: Boolean, default: false },
    payStatus: { default: 11 },
    price: { default: 0 },
    mode: { default: 'view' },
    isOldRecord: { type: Boolean, default: false }
  },
  emits: ['updatePopupShow'],
  setup(__props: any, { emit: emits }) {

const props = __props as { productGuid: string, productName: string, productImages: string[], productChild: Array<ChildProductItem>, guid: string, title: string, status: number, canChange: boolean, payStatus: number, price: number, mode: string, isOldRecord: boolean };

const $router: Router = useRouter()


const frontMoney = ref('1000.00')
const restMoney: ComputedRef<string | number> = computed(() => {
  return props.price ? (props.price - Number(frontMoney.value)).toFixed(2) : 0
})

function toChangeActivity() {
  if (!props.canChange) return
  Dialog.confirm({
    message:
      props.status === 3
        ? '您可在设备核验通过后更改一次套餐，后续将无法更改'
        : '您可在设备核验通过前及通过后各更改一次套餐',
    confirmButtonText: '更改套餐',
    cancelButtonText: '考虑看看',
    className: 'repair-dialog',
    width: 304,
  })
    .then(() => {
      console.log('更改套餐')
      $router.push({
        name: 'device-replace-v3-apply-choose-device',
        query: { record: props.guid, product: props.productGuid },
      })
    })
    .catch(() => {
      console.log('考虑看看')
    })
}
function onUpdatePopupShow(show: boolean) {
  emits('updatePopupShow', show)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RecordBlockWrapper, {
    class: "product-info",
    title: __props.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ActivityProduct, {
          name: __props.productName,
          images: __props.productImages,
          child: __props.productChild,
          showCount: "",
          onUpdatePopupShow: onUpdatePopupShow
        }, null, 8, ["name", "images", "child"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", null, [
          (__props.mode === 'view')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (__props.isOldRecord)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("div", _hoisted_5, "¥" + _toDisplayString(__props.price), 1)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("li", _hoisted_6, [
                        _createElementVNode("div", null, [
                          _createTextVNode(" 定金 "),
                          _createElementVNode("span", {
                            class: _normalizeClass(["pay-status", __props.payStatus > 11 ? 'payed' : ''])
                          }, _toDisplayString(__props.payStatus > 11 ? '已付款' : '待付款'), 3)
                        ]),
                        _createElementVNode("div", _hoisted_7, "¥" + _toDisplayString(frontMoney.value), 1)
                      ]),
                      (__props.payStatus !== 11)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                            _createElementVNode("div", null, [
                              _createTextVNode(" 尾款 "),
                              _createElementVNode("span", {
                                class: _normalizeClass(["pay-status", __props.payStatus > 21 ? 'payed' : ''])
                              }, _toDisplayString(__props.payStatus > 21 ? '已付款' : '待付款'), 3)
                            ]),
                            _createElementVNode("div", _hoisted_9, "¥" + _toDisplayString(_unref(restMoney)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("li", _hoisted_10, [
                        _createElementVNode("div", null, _toDisplayString(__props.payStatus === 11 ? '订单金额' : '订单金额（包含定金）'), 1),
                        _createElementVNode("div", _hoisted_11, "¥" + _toDisplayString(__props.payStatus === 11 ? frontMoney.value : __props.price), 1)
                      ])
                    ], 64))
              ], 64))
            : (__props.mode === 'pay')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("li", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, "¥" + _toDisplayString(__props.price), 1)
                  ]),
                  _createElementVNode("li", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, "－¥" + _toDisplayString(frontMoney.value), 1)
                  ]),
                  _createElementVNode("li", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, "¥" + _toDisplayString(_unref(restMoney)), 1)
                  ])
                ], 64))
              : _createCommentVNode("", true),
          (props.canChange)
            ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                _createElementVNode("div", {
                  class: "xag-flex-center",
                  onClick: toChangeActivity
                }, _hoisted_24)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})